import { render, staticRenderFns } from "./chart-union-area-legend.vue?vue&type=template&id=ee4450b2"
import script from "./chart-union-area-legend.vue?vue&type=script&lang=js"
export * from "./chart-union-area-legend.vue?vue&type=script&lang=js"
import style0 from "./chart-union-area-legend.vue?vue&type=style&index=0&id=ee4450b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports